import { IHttpRequestConfig } from "@/browser";
import { Typeahead } from "@/components/Typeahead";
import { fetchSkillsList, IFetchSkillsListParams, ISkill } from "@/data/skills";
import { ITypeaheadFactoryProps, ITypeaheadProps, typeaheadFactory } from "@/eworkitComponents";

const fetchProxy = async (query: IFetchSkillsListParams, options: IHttpRequestConfig) => {
  const results = await fetchSkillsList({ ...query, size: 30 }, options);
  return results.content;
};

export const TypeaheadSkills = typeaheadFactory<ITypeaheadProps, ISkill, IFetchSkillsListParams>(fetchProxy, Typeahead);

export type ITypeaheadSkillsProps = ITypeaheadFactoryProps<ITypeaheadProps, ISkill, IFetchSkillsListParams>;
